import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { structureLoopingGroup } from '../../utils/loopingGroup';
import { filterFieldsByFieldIds } from '../../utils/fieldId';
import FieldItem from '../FieldItem/FieldItem';
import FieldArrayContainer from '../FieldArrayContainer/FieldArrayContainer';
import { getSectionConditionsInfo } from '../../utils/condition/selectors';

var Section = /*#__PURE__*/function (_Component) {
  _inherits(Section, _Component);

  function Section() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Section);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Section)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.proceededLoopingGroups = [], _this.getLoopingGroupData = function (field) {
      var _this$props = _this.props,
          sections = _this$props.sections,
          fields = _this$props.fields;
      var section = sections.find(function (s) {
        return s.title === field.section;
      });
      var sectionFieldIds = section && section.fields || [];
      var allSectionFields = filterFieldsByFieldIds(fields, sectionFieldIds);
      return structureLoopingGroup(field, allSectionFields);
    }, _this.renderField = function (field, fieldIndex) {
      var _this$props2 = _this.props,
          handleChange = _this$props2.handleChange,
          uploadingFiles = _this$props2.uploadingFiles,
          files = _this$props2.files,
          fields = _this$props2.fields,
          country = _this$props2.country,
          language = _this$props2.language;
      return React.createElement(FieldItem, {
        key: fieldIndex,
        id: field.id,
        fields: fields,
        fieldTitle: field.fieldTitle,
        condition: field.conditionPostfix,
        restrictionValidation: field.restrictionValidation,
        handleChange: handleChange,
        fieldType: field.formType,
        required: field.required,
        note: field.note,
        listValues: field.listValues,
        uploadingFiles: uploadingFiles,
        files: files,
        country: country,
        language: language
      });
    }, _this.renderFieldArray = function (field, fieldIndex) {
      var _this$props3 = _this.props,
          handleChange = _this$props3.handleChange,
          uploadingFiles = _this$props3.uploadingFiles,
          files = _this$props3.files,
          fields = _this$props3.fields,
          country = _this$props3.country,
          language = _this$props3.language;

      if (_this.proceededLoopingGroups.includes(field.loopingGroup)) {
        return null;
      }

      _this.proceededLoopingGroups.push(field.loopingGroup);

      var loopingGroup = _this.getLoopingGroupData(field);

      return React.createElement(FieldArrayContainer, {
        key: fieldIndex,
        fields: fields,
        loopingGroup: loopingGroup,
        handleChange: handleChange,
        uploadingFiles: uploadingFiles,
        files: files,
        country: country,
        language: language
      });
    }, _this.getSectionFields = function () {
      var _this$props4 = _this.props,
          sectionItem = _this$props4.sectionItem,
          fields = _this$props4.fields;
      return sectionItem.fields.map(function (fieldId) {
        return fields.find(function (f) {
          return f.id === fieldId;
        });
      });
    }, _temp));
  }

  _createClass(Section, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          sectionItem = _this$props5.sectionItem,
          allFieldsHaveConditions = _this$props5.allFieldsHaveConditions,
          someFieldConditionsFulfilled = _this$props5.someFieldConditionsFulfilled;
      this.proceededLoopingGroups = [];

      if (allFieldsHaveConditions && !someFieldConditionsFulfilled) {
        return null;
      }

      return React.createElement(Fragment, null, React.createElement('h3', null, ' ', sectionItem.title, ' '), this.getSectionFields().map(function (field, fieldIndex) {
        return field.loopingGroup ? _this2.renderFieldArray(field, fieldIndex) : _this2.renderField(field, fieldIndex);
      }));
    }
  }]);

  return Section;
}(Component);

var mapStateToProps = function mapStateToProps(state, props) {
  var sectionItem = props.sectionItem,
      fields = props.fields;
  var sectionFieldIds = sectionItem.fields;
  var sectionFields = filterFieldsByFieldIds(fields, sectionFieldIds);
  return getSectionConditionsInfo(state, sectionFields);
};

export default connect(mapStateToProps)(Section);